// extracted by mini-css-extract-plugin
module.exports = {"burger-wrapper":"Header_burger-wrapper__1ZTT1","logo":"Header_logo__1BANP"};